module.exports = "/_next/static/images/boosts-hero-desktop-f910871facee4b057157af2bc8de0187.svg";